<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 4v5.26L9.63 19.59l-5.21-5.21L14.82 4H20m1-2h-6.59a1 1 0 00-.71.29L2.29 13.68a1 1 0 000 1.41l6.63 6.62a1 1 0 001.42 0l11.34-11.33a1 1 0 00.29-.7L22 3a1 1 0 00-1-1z"/><circle cx="16" cy="8" r="1.5"/></svg>